import d from './DOM.js';
import network from './network.js';

export interface Account {
	id: number;
	userID: number;
	accountNumber: string;
	brokerName: string;
	created: string;
	isDefault: boolean | number;
	balance: number;
}

export default class AccountManager {
	public static accounts: Account[] = [];
	public static currentAccount: Account | null = null;
	
	public static async init() {
		const result = await network.ag('/api/accounts');
		
		if (result.ok) {
			AccountManager.accounts = result.payload;
			AccountManager.determineCurrentAccount();
			// No renderSelector() here: the switcher is the host `account-switcher` island
			// (UNIT-91), which works on the Verified Edge pages too. This class stays the
			// source of truth for WHICH account is current — the island writes the same
			// localStorage key + cookie that determineCurrentAccount() reads.
		}
	}
	
	private static determineCurrentAccount() {
		let selected: Account | undefined;
		
		// 1. Check LocalStorage
		const storedAccountNum = localStorage.getItem('selectedAccount');
		if (storedAccountNum) { selected = AccountManager.accounts.find(a => a.accountNumber === storedAccountNum); }
		
		// 2. If not found, check Default
		if (!selected) { selected = AccountManager.accounts.find(a => a.isDefault); }
		
		// 3. If still not found, take first
		if (!selected && AccountManager.accounts.length > 0) { selected = AccountManager.accounts[0]; }
		
		AccountManager.currentAccount = selected || null;
		if (AccountManager.currentAccount) { localStorage.setItem('selectedAccount', AccountManager.currentAccount.accountNumber); }
	}
	
	public static async setAccount(accountNumber: string) {
		const account = AccountManager.accounts.find(a => a.accountNumber === accountNumber);
		
		if (account) {
			AccountManager.currentAccount = account;
			localStorage.setItem('selectedAccount', accountNumber);
			document.cookie = `selectedAccount=${accountNumber}; path=/; max-age=31536000`; // 1 year
			
			const url = new URL(window.location.href);
			url.searchParams.set('accountNumber', accountNumber);
			
			window.location.href = url.toString();
		}
	}
	
	public static async setDefault(accountNumber: string) {
		const result = await network.ap('/api/accounts/default', { accountNumber });
		
		if (result.ok) {
			// Update local state
			AccountManager.accounts.forEach(a => a.isDefault = (a.accountNumber === accountNumber));
		}
	}
}
